import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import FontCase from "%/dynamic-components/render-engine/options/text-options/font-case";
import TextWrap from "%/dynamic-components/render-engine/options/text-options/text-wrap";
import LineHeightMultiplier from "%/dynamic-components/render-engine/options/text-options/line-height-multiplier";
import TextDecoration from "%/dynamic-components/render-engine/options/text-options/text-decoration";
import FontStyle from "%/dynamic-components/render-engine/options/text-options/font-style";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import TextAlign from "%/dynamic-components/render-engine/options/text-options/text-align";
import TextOverflow from "%/dynamic-components/render-engine/options/text-options/text-overflow";
import MaxVerticalLines from "%/dynamic-components/render-engine/options/text-options/max-vertical-lines";

export default class TextOptions extends BaseOptionsBundle {

  optionTitle = "Advanced Typography";
  static optionClassName = "i-dynamic-text";
  inspectorToolGroup = "advanced-text";
  useInspectorLabel = false;

  static userInterfaceComponent = {
    component: inspectorTools.ADVANCED_TEXT_TOOL_SET,
    canSetOtherStates: [BaseOption.$states.HOVER],
  };

  constructor(values = {}, optionTitle = "Text Options") {
    super(values, [
      TextDecoration,
      FontStyle,
      TextWrap,
      TextOverflow,
      MaxVerticalLines,
      TextAlign,
      LineHeightMultiplier,
      FontCase,
    ]);
    this.optionTitle = optionTitle;
  }
}
